export const MENU_ITEMS = [
  { title: 'Typ klienta', url: '/customers' },
  { title: 'Dane klienta', url: '/information' },
  { title: 'Zgłoszenie', url: '/registration' },
  { title: 'Podsumowanie', url: '/summary' },
];

export const MENU_ITEMS_COMPANY = [
  { title: 'Typ klienta', url: '/customers' },
  { title: 'Dane Firmy', url: '/companySearch' },
  { title: 'Zgłoszenie', url: '/companyRegistration' },
  { title: 'Miejsce odbioru towaru', url: '/companyReceiptGoods' },
  { title: 'Podsumowanie', url: '/companySummary' },
];
